import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  TextArea,
} from '@app/shared';


@Injectable()
export class CalendarFormService {
  constructor() { }

  /**
   * Retorna el formulario de rechazo de tarea
   *
   * @returns {BaseControl<any>[]}
   * @memberof CalendarFormService
   */
  getFormReject(): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new TextArea({
        key: 'txtMotivo',
        label: 'Motivo:',
        rows: '5',
        notResize: false,
        value: null,
        order: 1,
        placeholder: 'Motivo del rechazo',
        validations: {
            validators: [
                Validators.required
            ]
        }
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/calendar/shared/calendar.forms.service.ts